import OutLineMobileOne from '@assets/icons/outline-mobile-one.svg'
import { Icon } from './Icon'

export const OutLineMobileOneIcon = Icon(OutLineMobileOne)
